"use client";

import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
	palette: {
		primary: {
			main: "#ea733b",
			contrastText: "#ffffff",
		},
		secondary: {
			main: "#4682b4",
			contrastText: "#ffffff",
		},
		background: {
			default: "#f9f9f9",
			paper: "#ffffff",
		},
	},
	components: {
		MuiCssBaseline: {
			styleOverrides: {
				"*": {
					textTransform: "none",
				},
				body: {
					textTransform: "none",
				},
			},
		},
		MuiOutlinedInput: {
			styleOverrides: {
				input: {
					padding: "8px",
				},
			},
		},
		MuiInputLabel: {
			styleOverrides: {
				root: {
					transform: "translate(14px, 8px) scale(1)",
				},
				shrink: {
					transform: "translate(14px, -10px) scale(0.75)",
				},
			},
		},
		MuiButton: {
			styleOverrides: {
				root: {
					textTransform: "none",
				},
			},
		},
	},
});
